export default "__VITE_ASSET__a0b82b65__"